import React, { memo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { Image, Youtube } from 'app/shared/components';

export interface MediaProps {
  className?: string;
}

function Media({ className }: MediaProps) {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const { imgs, youtubeid } = engine.getSubjectData(id);

  if (!(imgs || youtubeid)) {
    return null;
  }

  return (
    <div className={className} aria-label="subject media">
      {imgs && <Image src={imgs} lazyload />}
      {youtubeid && (
        <Youtube videoId={youtubeid} onStart={() => engine.startMedia(id)} />
      )}
    </div>
  );
}

export default memo(Media);
